<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-sending *ngIf="sending"></app-sending>
  <app-action-grid
    [data]="data"
    [loading]="loading"
    [rowSelection]="rowSelection"
    [columns]="columns"
    [actionButtons]="actionButtons"
    [cellClasses]="cellClasses"
    [exportExcelButton]="true"
    (actionCommit)="actionCommit($event)"
  ></app-action-grid>
</app-main-contents>

<!-- 御見積書確認モーダル -->
<app-ura-prosche-application-detail-modal></app-ura-prosche-application-detail-modal>
